var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00733 9.58151L0.398358 2.22391C0.272132 2.10306 0.171944 1.95929 0.103573 1.80088C0.0352013 1.64247 6.43679e-08 1.47257 5.68668e-08 1.30096C4.93656e-08 1.12935 0.0352013 0.959445 0.103573 0.801037C0.171944 0.642629 0.272132 0.498855 0.398358 0.37801C0.650683 0.135897 0.992012 -4.33622e-08 1.3478 -5.8914e-08C1.70358 -7.44659e-08 2.04491 0.135897 2.29724 0.37801L9.03084 6.81266L15.6971 0.378009C15.9494 0.135896 16.2908 -7.12092e-07 16.6465 -7.27644e-07C17.0023 -7.43195e-07 17.3437 0.135896 17.596 0.378009C17.7232 0.498401 17.8245 0.641972 17.8938 0.800401C17.9632 0.958831 17.9993 1.12897 18 1.30096C17.9993 1.47295 17.9632 1.64309 17.8938 1.80152C17.8245 1.95995 17.7232 2.10352 17.596 2.22391L9.98701 9.58151C9.8609 9.71346 9.70785 9.81876 9.53749 9.89079C9.36713 9.96282 9.18316 10 8.99717 10C8.81119 10 8.62722 9.96282 8.45686 9.89079C8.2865 9.81876 8.13344 9.71346 8.00733 9.58151Z",
    fill: "#09035D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e09d288b50fdfe3acf82c990c9c1c72d.svg";
export { ForwardRef as ReactComponent };